// extracted by mini-css-extract-plugin
export default {"previewCard":"previewCard_WidgetWrappers-module_FtGjq"};